import DashboardIcon from '@mui/icons-material/Dashboard'
import AssignmentIcon from '@mui/icons-material/Assignment'
import ViewKanbanIcon from '@mui/icons-material/ViewKanban'
import Inventory2Icon from '@mui/icons-material/Inventory2'
import LinkIcon from '@mui/icons-material/Link'
import LabelIcon from '@mui/icons-material/Label'
import SensorsIcon from '@mui/icons-material/Sensors'
import ManageSearchIcon from '@mui/icons-material/ManageSearch'
import TimelineIcon from '@mui/icons-material/Timeline'
import AccountTreeIcon from '@mui/icons-material/AccountTree'
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing'
import UploadFileIcon from '@mui/icons-material/UploadFile'
import AssessmentIcon from '@mui/icons-material/Assessment'
import PeopleIcon from '@mui/icons-material/People'
import HistoryEduIcon from '@mui/icons-material/HistoryEdu'
import StorageIcon from '@mui/icons-material/Storage'
import SyncIcon from '@mui/icons-material/Sync'
import { PERMISSOES } from './permissoes'

/**
 * Base do painel SSO. A gestão de usuários é delegada ao SSO, então o item
 * "Usuários" redireciona para lá em vez de abrir uma tela local.
 */
export const SSO_URL = process.env.REACT_APP_SSO_URL || 'https://sso.innerconnect.com.br'

/**
 * Estrutura do menu lateral.
 *
 * `permissao` é a chave cadastrada no SSO; sem ela, o item é visível para
 * qualquer autenticado. Esconder o item do menu evita levar a pessoa a uma
 * tela onde ela só receberia 403.
 *
 * `external: true` + `href` abrem uma URL fora do app (redirect) em vez de
 * navegar por rota interna.
 */
export const MENU_GROUPS = [
  {
    title: 'Produção',
    items: [
      { label: 'Dashboard', path: '/dashboard', icon: DashboardIcon, permissao: PERMISSOES.DASHBOARD_VISUALIZAR },
      {
        label: 'Ordens de Produção',
        path: '/MovBreak',
        icon: AssignmentIcon,
        permissao: PERMISSOES.ORDEM_VISUALIZAR,
      },
      { label: 'Kanban', path: '/MovBreakKanban', icon: ViewKanbanIcon, permissao: PERMISSOES.KANBAN_VISUALIZAR },
    ],
  },
  {
    title: 'Cadastros',
    items: [
      { label: 'Produtos', path: '/products', icon: Inventory2Icon, permissao: PERMISSOES.PRODUTO_VISUALIZAR },
      {
        label: 'Carga de Produtos',
        path: '/chargeProduct',
        icon: UploadFileIcon,
        permissao: PERMISSOES.PRODUTO_GERENCIAR,
      },
      {
        label: 'Fator de Conversão',
        path: '/QuantityBox',
        icon: Inventory2Icon,
        permissao: PERMISSOES.PRODUTO_VISUALIZAR,
      },
      {
        label: 'Associação de Produtos',
        path: '/ProductAssociation',
        icon: LinkIcon,
        permissao: PERMISSOES.RFID_VISUALIZAR,
      },
      {
        label: 'Receita de Máquina',
        path: '/machineRecipe',
        icon: PrecisionManufacturingIcon,
        permissao: PERMISSOES.RECEITA_VISUALIZAR,
      },
      {
        label: 'Etiquetas ZPL',
        path: '/PrinterZpl',
        icon: LabelIcon,
        permissao: PERMISSOES.RFID_VISUALIZAR,
      },
      {
        label: 'Carga de Receita',
        path: '/chargeRecipeMachine',
        icon: UploadFileIcon,
        permissao: PERMISSOES.RECEITA_GERENCIAR,
      },
    ],
  },
  {
    title: 'RFID',
    items: [
      { label: 'Rastreamento', path: '/RfidTracking', icon: SensorsIcon, permissao: PERMISSOES.RFID_VISUALIZAR },
      { label: 'Consulta de RFIDs', path: '/RfidQuery', icon: ManageSearchIcon, permissao: PERMISSOES.RFID_VISUALIZAR },
      { label: 'Linha do Tempo', path: '/RfidTimeline', icon: TimelineIcon, permissao: PERMISSOES.RFID_VISUALIZAR },
    ],
  },
  {
    title: 'Configuração',
    items: [
      { label: 'Fluxos de Produção', path: '/ProcessFlow', icon: AccountTreeIcon, permissao: PERMISSOES.FLUXO_VISUALIZAR },
      {
        label: 'Usuários',
        href: `${SSO_URL}/empresa/usuarios`,
        external: true,
        icon: PeopleIcon,
        permissao: PERMISSOES.USUARIO_VISUALIZAR,
      },
      { label: 'Auditoria', path: '/Audit', icon: HistoryEduIcon, permissao: PERMISSOES.AUDITORIA_VISUALIZAR },
      {
        label: 'Migração',
        path: '/Migration',
        icon: StorageIcon,
        permissao: PERMISSOES.SINCRONIZACAO_VISUALIZAR,
      },
      {
        label: 'Sincronização',
        path: '/Sync',
        icon: SyncIcon,
        permissao: PERMISSOES.SINCRONIZACAO_VISUALIZAR,
      },
    ],
  },
  {
    title: 'Relatórios',
    items: [{ label: 'Relatórios', path: '/Reports', icon: AssessmentIcon, permissao: PERMISSOES.RELATORIO_VISUALIZAR }],
  },
]
